import type { KeyboardEvent } from 'react';
import classNames from 'classnames';

import IconButtonV2 from '../../../IconButtonV2';
import Spinner from '../../../Spinner';
import TextArea from '../../../TextArea';
import { ArrowRightIcon } from '../../../../icons';

import styles from './_index.module.scss';

interface ChatInputProps {
  hasInputText: boolean;
  isDisabled: boolean;
  isLoading: boolean;
  isSubmitDisabled: boolean;
  onChange: (value: string) => void;
  onKeyDown: (event: KeyboardEvent<HTMLTextAreaElement>) => void;
  onSubmit: () => void;
  value: string;
}

const ChatInput = ({
  hasInputText,
  isDisabled,
  isLoading,
  isSubmitDisabled,
  onChange,
  onKeyDown,
  onSubmit,
  value,
}: ChatInputProps) => (
  <div
    className={classNames(styles['chat-input-field'], {
      [styles['chat-input-field-loading']]: isLoading,
    })}
  >
    <div className={styles['chat-input-textarea']}>
      <TextArea
        autoGrow
        className={styles['chat-input-control']}
        isDisabled={isDisabled}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder="How can I help?"
        rows={1}
        value={value}
      />
    </div>

    {isLoading ? (
      <span
        className={classNames(styles['chat-input-submit'], styles['chat-input-submit-spinner'])}
        data-testid="chat-input-submit-spinner"
      >
        <Spinner className={styles['chat-input-spinner']} />
      </span>
    ) : (
      <span
        className={classNames(styles['chat-input-submit'], {
          [styles['chat-input-submit-filled']]: hasInputText,
        })}
      >
        <IconButtonV2
          aria-label="Submit prompt"
          disabled={isSubmitDisabled || !hasInputText}
          icon={<ArrowRightIcon />}
          onClick={onSubmit}
          size="small"
          variant="subtle"
        />
      </span>
    )}
  </div>
);

export default ChatInput;
